import { ADMIN, CURATOR, CUSTOMER, CUSTOMER_EXPERIENCE, DEVELOPER, QUALITY_ASSURANCE } from "entities/user/role";
import useRole from "hooks/useRole";
import { DefaultPermission } from "utils/permission";

export default function useLoyaltyRewardsPermissions(): DefaultPermission {
  const { hasRole, hasNotRole } = useRole()

  return {
    canCreate: hasRole(ADMIN, DEVELOPER, QUALITY_ASSURANCE, CURATOR),
    canEdit: hasRole(ADMIN, DEVELOPER, QUALITY_ASSURANCE, CUSTOMER_EXPERIENCE, CURATOR),
    canDelete: hasRole(ADMIN, DEVELOPER, QUALITY_ASSURANCE, CURATOR),
    canList: hasNotRole(CUSTOMER),
    canShow: hasNotRole(CUSTOMER)
  }
}
